import '../Model/Query';
import { Bussiness } from '../Model/Bussiness';
export class BussinessService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findBussiness() {
        /* if ((opts?.offset || opts.offset >= 0) && opts?.limit) { */
        /* const query = new Query(opts.offset, opts.limit);

        if (opts.filters?.search) {
            query.addFilter('search', [opts.filters.search]);
        }

        const params = this.queryParamsFactory.createQueryParams(query) */
        const response = await this.apiService.get(`bussiness`);
        if (!response.ok) {
            throw new Error(`Error al obtener los negocios.`);
        }
        const content = await response.json();
        return content.map(diligence => new Bussiness(diligence).getState());
        /* }else{
            throw new Error(`Error al obtener opts.`);
        } */
    }
    async findOne(id) {
        if (id) {
            const response = await this.apiService.get('bussiness/' + id);
            if (!response.ok) {
                throw new Error(`Error al obtener a empresa`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener la empresa`);
        }
    }
}
